export default "__VITE_PUBLIC_ASSET__70b23442__"